export default [{
    path: '/delivery-types',
    name: 'delivery-types',
    component: () =>
        import ('@/views/modules/deliverytypes/DeliveryTypesList.vue'),
    meta: {
        resource: 'ACL',
        pageTitle: 'Envío y Entrega',
        breadcrumb: [{
            text: 'Tipos de entrega',
            active: true
        }]
    }
}]
